/**
 * OAuth callback page for Gmail Extractor.
 * When Google redirects here with ?code=, the opener (Gmail Extractor) polls
 * this window's URL, extracts the code, and closes the popup.
 */
import React from 'react';

const AuthCallback: React.FC = () => (
  <div
    style={{
      textAlign: 'center',
      padding: 60,
      fontFamily: 'system-ui',
      color: '#e4e4eb',
      background: '#0f0f13',
      minHeight: '100vh',
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
    }}
  >
    <h2>Signed in!</h2>
    <p>This window will close automatically...</p>
  </div>
);

export default AuthCallback;
